<template>
<div>
  <div class="partner">
    <ul class="w1200">
      <li class="clear border_b">
        <img src="@/assets/pc/images/partner_01.png" alt />
        <div class="desc">
          <h3>生态合作伙伴</h3>
          <p>如果您有成熟的企业生态服务产品，可将您的产品集成在X联网中为更多的客户提供服务</p>
          <el-button  @click="showDialog = true;systemId= '4'">立即加入</el-button>
        </div>
      </li>
      <li class="clear">
        <img src="@/assets/pc/images/partner_02.png" alt />
        <div class="desc">
          <h3>推广合作伙伴</h3>
          <p>如果您对我们感兴趣并拥有丰富人脉资源，可与我们一起共同推广X联网解决方案</p>
          <el-button  @click="showDialog = true;systemId= '5'">立即加入</el-button>
        </div>
      </li>
    </ul>
    </div>
    <dialog-box
      :showDialog="showDialog"
      :systemId ="systemId"
      @close="showDialog = false"
    ></dialog-box>
  </div>
</template>
<script>
import dialogBox from './components/dialog'
export default {
  components: {
    dialogBox,
  },
  data() {
    return {
      systemId:'4',
      showDialog: false,
    }
  }
}
</script>


<style lang="scss">
@import "~@/assets/pc/css/partner.scss";
</style>